module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.b6feb893.png";